import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import Tooltip from 'builder/components/Tooltip'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { actions as uiActions } from 'builder/modules/ui'
import { i18n } from 'builder/utils/i18n'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { useConfig } from 'builder/hooks/useConfig'
import {
  Container,
  CrownIcon,
  CrownIconContainer,
  DaysCountButton,
  RenewButton,
  TrailDaysText,
} from './styles'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors as userSelectors } from 'builder/modules/user'

interface IProps {
  daysLeftPremium: number
  [x: string]: any // rest
}

export const PremiumTracker = ({ daysLeftPremium, ...rest }: IProps) => {
  const { isPhone } = useMediaQueries()
  const dispatch = useDispatch()
  const config = useConfig()
  const user = useTypedSelector(userSelectors.userData)

  const handleModalOpen = useCallback(() => {
    dispatch(uiActions.openRestartSubscriptionModal())
  }, [dispatch])

  const handlePremiumUpgrade = () => {
    if (daysLeftPremium > 0) {
      trackInternalEvent('click_keep_premium', { label: 'navigation' })
    }
    goToBillingPlanPage()
  }

  return (
    <Container daysLeftPremium={daysLeftPremium} {...rest}>
      <Tooltip
        position="bottom"
        multiline={!!isPhone}
        value={
          daysLeftPremium < 1
            ? i18n.t(`builder.navigation.post_premium.premium_over`)
            : i18n.t(`builder.navigation.post_premium.premium_warning`)
        }
      >
        <DaysCountButton>
          <CrownIconContainer>
            <CrownIcon />
          </CrownIconContainer>
          <TrailDaysText>
            {i18n.t(
              isPhone
                ? `builder.navigation.post_premium.days_left_shorthand`
                : `builder.navigation.post_premium.days_left`,
              {
                days_left_count: daysLeftPremium < 1 ? 0 : daysLeftPremium,
              },
            )}
          </TrailDaysText>
        </DaysCountButton>
      </Tooltip>

      {!isPhone && (
        <RenewButton
          onClick={() => {
            if (config?.features.reactivatePremium && user?.billingInfo.canRestartSubscription) {
              handleModalOpen()
              trackInternalEvent('click_keep_premium', { where: 'dash' })
            } else handlePremiumUpgrade()
          }}
        >
          {daysLeftPremium < 1
            ? i18n.t(`builder.navigation.post_premium.renew`)
            : i18n.t(`builder.navigation.post_premium.keep`)}{' '}
          {i18n.t(`builder.navigation.post_premium.premium`)}
        </RenewButton>
      )}
    </Container>
  )
}
